var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { attrs: { sm12: "" } },
    [
      _c(
        "v-card",
        { staticClass: "rounded-card" },
        [
          _c(
            "v-container",
            { attrs: { "grid-list-md": "" } },
            [
              _c("h2", { staticClass: "h2_title mb-1" }, [
                _vm._v("\n        Información General\n      ")
              ]),
              _c("v-divider"),
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm12: "",
                    md12: "",
                    "mt-5": "",
                    layout: "",
                    wrap: ""
                  }
                },
                _vm._l(_vm.cols, function(item) {
                  return _c(
                    "v-flex",
                    { key: item.id, attrs: { xs12: "", sm4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: item.field, readonly: "" },
                        model: {
                          value: _vm.data[item.id],
                          callback: function($$v) {
                            _vm.$set(_vm.data, item.id, $$v)
                          },
                          expression: "data[item.id]"
                        }
                      })
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }